import { useQuery } from 'react-query';
import { fetchRegistrantClass } from '@general/api/eventAPI';

const useRegistrantClassFromAPI = ({ memberId, cartId, eventId }) => {
    const { data, ...rest } = useQuery(
        `registrant-class-${memberId}-${cartId}-${eventId}`,
        async () => {
            if (!memberId || !cartId || !eventId) {
                return null;
            }

            const response = await fetchRegistrantClass({ memberId, cartId, eventId });
            return response.data?.data || null;
        },
        {
            enabled: !!memberId && !!cartId && !!eventId,
            staleTime: Infinity,
        }
    );

    return { registrantClass: data, ...rest };
};

export default useRegistrantClassFromAPI;
